import FilterForm from 'components/forms/FilterForm';
import { useSelect } from '@refinedev/antd';
import { Form, FormProps, Input, Select, Space } from 'antd';
import { ICourse } from 'interfaces/courses';
import { IGraduateCourse } from 'interfaces/graduate_courses';
import { useEffect } from 'react';

export interface ICompanyContractsFilter {
  by_course_type: string;
  by_code: string;
  by_course_id: string;
  starts_after: Date;
  expires_before: Date;
}

interface ContractsFilterProps {
  searchFormProps: FormProps<ICompanyContractsFilter>;
}

const COURSE_TYPE_OPTIONS = [
  { label: 'Curso Livre', value: 'Course' },
  { label: 'Pós-graduação', value: 'Graduate::Course' }
];

export const ContractsFilter = ({ searchFormProps }: ContractsFilterProps) => {
  const selectedCourseType = Form.useWatch('by_course_type', searchFormProps.form);
  const isFreeCourse = selectedCourseType === 'Course';
  const isGraduateCourse = selectedCourseType === 'Graduate::Course';

  const { selectProps: freeCourseSelectProps } = useSelect<ICourse>({
    resource: 'courses',
    optionLabel: 'name',
    optionValue: 'id',
    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],
    pagination: {
      mode: 'server',
      pageSize: 100
    },
    queryOptions: {
      enabled: isFreeCourse
    }
  });

  const { selectProps: graduateCourseSelectProps } = useSelect<IGraduateCourse>({
    resource: 'graduate_courses',
    optionLabel: 'name',
    optionValue: 'id',
    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],
    pagination: {
      mode: 'server',
      pageSize: 100
    },
    queryOptions: {
      enabled: isGraduateCourse
    }
  });

  const courseSelectProps = isFreeCourse
    ? freeCourseSelectProps
    : isGraduateCourse
      ? graduateCourseSelectProps
      : undefined;

  useEffect(() => {
    searchFormProps.form?.setFieldValue('by_course_id', undefined);
  }, [searchFormProps.form, selectedCourseType]);

  return (
    <Space direction="vertical" size="middle" className="w-full">
      <FilterForm
        searchFormProps={searchFormProps}
        okButtonProps={{
          type: 'primary'
        }}
      >
        <Form.Item name="by_course_type" className="mb-0 w-45">
          <Select
            allowClear
            placeholder="Modalidade"
            options={COURSE_TYPE_OPTIONS}
          />
        </Form.Item>

        <Form.Item name="by_course_id">
          <Select
            placeholder="Cursos"
            disabled={!selectedCourseType}
            {...courseSelectProps}
            allowClear
          />
        </Form.Item>

        <Form.Item name="by_code">
          <Input placeholder="Contrato" />
        </Form.Item>
      </FilterForm>
    </Space>
  );
};
